// import React, { useState, useMemo } from 'react';
// /*------------------------ Date Picker : BuddhistEra --------------*/
// import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import buddhistEra from 'dayjs/plugin/buddhistEra';
// import 'dayjs/locale/th';

// dayjs.locale('th');
// dayjs.extend(buddhistEra);

// const dateformats = {
//     year: "BBBB",
//     monthAndYear: "MMMM BBBB",
//     keyboardDate: "DD/MM/BBBB",
// };

// const th_montharr = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

// const OwnDatePickerExamMgmt = (props) => {
//     const { currdate, setNewResvDate } = props;
//     //const [calendardate, setCalendarDate] = useState(currdate);
//     const [calendardate, setCalendarDate] = useState(null);
//     useMemo(() => {
//         setCalendarDate(currdate);
//     },[currdate])

//     const thDateFormatFunc = (date) => {
//         let thdate = dayjs(date).format('DD-MM-BBBB');
//         let thmonth = th_montharr[Number(thdate.split('-')[1]) - 1];
//         return (thdate.split('-')[0] + ' ' + thmonth + ' ' + thdate.split('-')[2]);
//     }

//     return (
//         <LocalizationProvider
//             adapterLocale={'th'}
//             dateAdapter={AdapterDayjs}
//             dateFormats={dateformats}
//         >
//             <DatePicker
//                 maxDate={dayjs(new Date(3000, 12, 31))}
//                 minDate={dayjs(new Date(1990, 1, 1))}
//                 views={['year', 'month', 'day']}
//                 sx={{
//                     minWidth: 150,
//                     '& .MuiInputBase-input': {
//                         fontFamily: 'THSarabunNew',
//                         fontSize: 12,
//                     },
//                     boxShadow: 'none',
//                     '.MuiOutlinedInput-notchedOutline': { border: 0 },
//                     '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
//                     '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
//                 }}
//                 onChange={(newdate) => {
//                     if (dayjs(newdate).get('day') !== 0 && dayjs(newdate).get('day') !== 6) {
//                         setCalendarDate(thDateFormatFunc(newdate));
//                         setNewResvDate(dayjs(newdate).format('YYYY-MM-DD'));
//                     }
//                 }}
//                 slotProps={{
//                     textField: {
//                         inputProps: {
//                             value: calendardate,
//                         },
//                     }
//                 }}
//             />
//         </LocalizationProvider>
//     );
// }

// export default OwnDatePickerExamMgmt;


import React, { useState, useMemo } from 'react';
import { convertToEngDate } from "./functions/GlobalFunctions";
/*------------------------ Date Picker : BuddhistEra --------------*/
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import 'dayjs/locale/th';

dayjs.locale('th');
dayjs.extend(buddhistEra);

const dateformats = {
    year: "BBBB",
    monthAndYear: "MMMM BBBB",
    keyboardDate: "DD/MM/BBBB",
};

const th_montharr = ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'];

const OwnDatePickerExamMgmt = (props) => {
    const { disabled, currdate, setNewResvDate } = props;
    //const [calendardate, setCalendarDate] = useState(currdate);
    const [calendardate, setCalendarDate] = useState(null);
    useMemo(() => {
        setCalendarDate(currdate);
    }, [currdate])

    const thDateFormatFunc = (date) => {
        let thdate = dayjs(date).format('DD-MM-BBBB');
        let thmonth = th_montharr[Number(thdate.split('-')[1]) - 1];
        return (thdate.split('-')[0] + ' ' + thmonth + ' ' + thdate.split('-')[2]);
    }

    return (
        <LocalizationProvider
            adapterLocale={'th'}
            dateAdapter={AdapterDayjs}
            dateFormats={dateformats}
        >
            <DatePicker
                maxDate={dayjs(new Date(3000, 12, 31))}
                minDate={dayjs(new Date(1990, 1, 1))}
                views={['year', 'month', 'day']}
                disabled={disabled}
                sx={{
                    minWidth: 150,
                    '& .MuiInputBase-input': {
                        fontFamily: 'THSarabunNew',
                        fontSize: 12,
                    },
                    boxShadow: 'none',
                    '.MuiOutlinedInput-notchedOutline': { border: 0 },
                    '&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': { border: 0 },
                    '&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 0 },
                }}
                onChange={(newdate) => {
                    let sel_date = dayjs(newdate).format('YYYY-MM-DD');
                    let m_today = dayjs().format('YYYY-MM-DD');
                    let resv_date = convertToEngDate(currdate);
                    console.log('dayjs ---> ', m_today, ' : ', resv_date, ' : ', sel_date, ' : ', dayjs(resv_date).diff(dayjs(m_today), 'day'))
                    if (dayjs(newdate).get('day') !== 0 && dayjs(newdate).get('day') !== 6) {
                        setCalendarDate(thDateFormatFunc(newdate));
                        setNewResvDate(dayjs(newdate).format('YYYY-MM-DD'));
                    }
                }}
                slotProps={{
                    textField: {
                        inputProps: {
                            value: calendardate,
                        },
                    }
                }}
            />
        </LocalizationProvider>
    );
}

export default OwnDatePickerExamMgmt;
